

























































































































import { Component, Vue } from "vue-property-decorator";
import CBlock from "@/components/form/CustomPage/CBlock.vue";
import CField from "@/components/form/CField.vue";
import CustomButton from "@/components/form/CustomButton.vue";
import { documentNumberApi } from "@/getinfo-api";
import { getCurrentCompanyId } from "@/plugins/roles";
import {
  NumberSequenceCreate as INumberSequenceCreate,
  NumberSequenceCreateStrategyEnum,
  NumberSequenceCreateTypeEnum
} from "@/api-v2/document-number/models/number-sequence-create";
import CSingleSelect from "@/components/form/CSingleSelect.vue";
import SearchInput from "@/components/form/SearchInput.vue";
import moment from "moment";

@Component({
  components: { SearchInput, CSingleSelect, CustomButton, CField, CBlock }
})
export default class DocumentNumberForm extends Vue {
  title: string = "";
  index: number = 1;
  suffix: string = "";
  postfix: string = "";
  isFilledIndex: boolean = false;
  fillCount: number | undefined = 5;
  isSavingProcess: boolean = false;
  isUseDateIndex: boolean = false;
  strategy?: NumberSequenceCreateStrategyEnum =
    NumberSequenceCreateStrategyEnum.Day;
  type: NumberSequenceCreateTypeEnum = NumberSequenceCreateTypeEnum.Unset;

  get companyId() {
    return getCurrentCompanyId();
  }

  get types(): typeof NumberSequenceCreateTypeEnum {
    return NumberSequenceCreateTypeEnum;
  }

  get strategies() {
    return NumberSequenceCreateStrategyEnum;
  }

  get currentDate() {
    const now = new Date();
    return {
      day: moment(now).format("DD"),
      month: moment(now).format("MM"),
      year: moment(now).format("YY"),
      fullYear: moment(now).format("YYYY")
    };
  }

  get previewResult(): string {
    const filledPreview = () => {
      const zeroPad = (num: number, places: number) =>
        String(num).padStart(places, "0");

      const count = this.fillCount ?? 1;
      return `${zeroPad(this.index ?? 1, count)}`;
    };

    const suffix = this.checkPreviewDate(this.suffix) ?? "";
    const index = `${this.isFilledIndex ? filledPreview() : this.index}`;
    const postfix = this.checkPreviewDate(this.postfix) ?? "";

    return suffix + index + postfix;
  }

  get rawFormat(): string {
    const suffix = this.suffix ?? "";
    const index = `{index|${this.isFilledIndex ? this.fillCount : 1}}`;
    const postfix = this.postfix ?? "";

    return suffix + index + postfix;
  }

  get availableDateSuffixes() {
    const allDates = () => [
      { value: this.$t(this.$translate.Day), body: "day" },
      { value: this.$t(this.$translate.Month), body: "month" },
      { value: this.$t(this.$translate.Year), body: "year" },
      { value: this.$t(this.$translate.FullYear), body: "full_year" }
    ];

    return allDates().filter(el => !this.suffix?.includes(el.body));
  }

  get availableDatePostfixes() {
    const allDates = () => [
      { value: this.$t(this.$translate.Day), body: "day" },
      { value: this.$t(this.$translate.Month), body: "month" },
      { value: this.$t(this.$translate.Year), body: "year" },
      { value: this.$t(this.$translate.FullYear), body: "full_year" }
    ];

    return allDates().filter(el => !this.postfix?.includes(el.body));
  }

  async getDateSuffixes() {
    return this.availableDateSuffixes;
  }

  async getDatePostfixes() {
    return this.availableDatePostfixes;
  }

  checkPreviewDate = (value: string) => {
    const day = /{day}/gi;
    const month = /{month}/gi;
    const year = /{year}/gi;
    const fullYear = /{full_year}/gi;
    return value
      ?.replaceAll(day, `${this.currentDate.day}`)
      ?.replaceAll(month, `${this.currentDate.month}`)
      ?.replaceAll(year, `${this.currentDate.year}`)
      ?.replaceAll(fullYear, `${this.currentDate.fullYear}`);
  };

  addToSuffix(value: {
    value: string;
    body: "day" | "month" | "year" | "full_year";
  }) {
    this.suffix = (this.suffix ?? "") + `{${value.body}}`;
  }

  addToPostfix(value: {
    value: string;
    body: "day" | "month" | "year" | "full_year";
  }) {
    this.postfix = (this.postfix ?? "") + `{${value.body}}`;
  }

  async save() {
    if (await this.$store.dispatch("validate/CHECK_VALIDATIONS")) return;

    const createModelParams: INumberSequenceCreate = {
      title: this.title,
      index: Number(this.index),
      type: this.type,
      strategy: this.isUseDateIndex ? this.strategy : undefined,
      format: this.rawFormat
    };

    try {
      this.isSavingProcess = true;
      const { data } = await documentNumberApi.createSequence(
        this.companyId,
        createModelParams
      );
      this.$emit("create", data);
    } catch (e) {
      throw new Error(e as any);
    } finally {
      this.isSavingProcess = false;
    }
  }

  checkSymbolLength(value: number) {
    return value > 11 ? 10 : value;
  }
}
